package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import ru.chm.gradereport.model.AttendanceStatus
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.MutedText
import ru.chm.gradereport.ui.components.SecondaryButton
import ru.chm.gradereport.ui.components.rememberSoftHover
import ru.chm.gradereport.ui.components.softFieldColors
import ru.chm.gradereport.ui.components.softHoverable
import ru.chm.gradereport.ui.theme.GradeTheme

internal data class AttendanceEditTarget(
    val studentId: String,
    val studentName: String,
    val sessionId: String,
    val sessionLabel: String,
    val current: AttendanceStatus?,
)

@Composable
internal fun AttendancePickerDialog(
    target: AttendanceEditTarget,
    onDismiss: () -> Unit,
    onSelect: (AttendanceStatus) -> Unit,
    onClear: () -> Unit,
) {
    val colors = GradeTheme.colors
    Dialog(onDismissRequest = onDismiss) {
        AppCard(modifier = Modifier.widthIn(min = 300.dp, max = 420.dp)) {
            Text("Посещаемость", color = colors.textPrimary, fontWeight = FontWeight.Bold, fontSize = 20.sp)
            MutedText(target.studentName, modifier = Modifier.padding(top = 4.dp))
            Text(
                target.sessionLabel,
                color = SessionAccent,
                fontSize = 14.sp,
                modifier = Modifier.padding(top = 2.dp, bottom = 12.dp),
            )

            AllAttendanceStatuses.forEach { status ->
                AttendanceOptionRow(
                    status = status,
                    selected = status == target.current,
                    onClick = { onSelect(status) },
                )
            }

            Row(
                modifier = Modifier.fillMaxWidth().padding(top = 12.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                SecondaryButton(text = "Отмена", onClick = onDismiss, modifier = Modifier.weight(1f))
                SecondaryButton(text = "Очистить", onClick = onClear, modifier = Modifier.weight(1f))
            }
        }
    }
}

@Composable
private fun AttendanceOptionRow(
    status: AttendanceStatus,
    selected: Boolean,
    onClick: () -> Unit,
) {
    val colors = GradeTheme.colors
    val color = statusColor(status)
    val shape = RoundedCornerShape(10.dp)
    val hover = rememberSoftHover()
    val (bg, border) = softFieldColors(
        state = hover,
        idleBg = if (selected) color.copy(alpha = 0.18f) else Color.Transparent,
        hoverBg = color.copy(alpha = if (selected) 0.28f else 0.14f),
        pressBg = color.copy(alpha = 0.34f),
        idleBorder = if (selected) color.copy(alpha = 0.55f) else colors.border,
        hoverBorder = color.copy(alpha = 0.75f),
        pressBorder = color.copy(alpha = 0.9f),
    )

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 4.dp)
            .softHoverable(hover)
            .background(bg, shape)
            .border(1.dp, border, shape)
            .clickable(
                interactionSource = hover.interactionSource,
                indication = null,
                onClick = onClick,
            )
            .padding(horizontal = 12.dp, vertical = 12.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(12.dp),
    ) {
        Text(
            statusLabel(status),
            color = color,
            fontWeight = FontWeight.Bold,
            fontSize = 20.sp,
        )
        Text(
            statusFullLabel(status),
            color = colors.textPrimary,
            fontSize = 15.sp,
        )
    }
}
